import type { ContractRenderData } from './types';
import { findFieldByRef } from './fieldMatch';
import { formatUnknownValue } from '../utils/formatValue';

/** 解析 {字段名} 文件名模板，用当前记录值填充；去掉文件名非法字符。 */
export function resolveFileNameTemplate(tpl: string, data: ContractRenderData): string {
  const name = tpl.replace(/\{([^}]+)\}/g, (_, ref: string) => {
    const m = findFieldByRef(data.mainFieldMetas, ref.trim());
    const raw = m ? data.mainRecord[m.id] : '';
    if (raw == null) return '';
    if (typeof raw === 'string' || typeof raw === 'number') return String(raw);
    if (Array.isArray(raw)) return raw.map((x) => (x && typeof x === 'object' && 'text' in x ? (x as { text: string }).text : formatUnknownValue(x))).join('');
    return formatUnknownValue(raw);
  });
  return (name.replace(/[\\/:*?"<>|]/g, '_').trim() || '导出文件').slice(0, 80);
}
